import oidc from "Services/oidc";
import swal from "sweetalert2";
import includes from "lodash/includes";

const state = {
  me: null,
  isAuthenticated: false
};

const getters = {
  getMe: state => state.me,
  isAuthenticated: state => state.isAuthenticated
};

function showAuthError(title, message) {
  swal
    .mixin({
      confirmButtonClass: "v-btn blue-grey subheading white--text",
      buttonsStyling: false,
      target: ".v-application"
    })
    .fire({
      title,
      html: `<p class="title">${message}</p>`,
      type: "error",
      confirmButtonText: "Back"
    });
}

function redirectAfterLogin(me) {
  const roles = (me && me.roles) || [];

  if (includes(roles, "vanzari")) {
    vm.$router.replace({ name: "offers-index" });
    return;
  }

  vm.$router.replace({ name: "dashboard" });
}

const actions = {
  async login(_, form) {
    if (form) {
      form.busy = true;
    }

    try {
      await oidc.signinRedirect();
    } catch (error) {
      if (form) {
        form.busy = false;
      }

      showAuthError(
        "Autentificare indisponibila",
        "Configuratia OpenID Connect lipseste sau nu este valida."
      );

      throw error;
    }
  },

  async completeOidcLogin({ commit, dispatch, getters }) {
    await oidc.signinRedirectCallback();
    commit("isAuthenticated", true);
    await dispatch("fetchMe");

    redirectAfterLogin(getters.getMe);
  },

  async logout({ commit }, form) {
    if (form) {
      form.busy = true;
    }

    await axios.post(route("api.auth.logout")).catch(() => {});
    await axios.post(route("auth.logout")).catch(() => {});
    await oidc.removeUser();

    commit("logout");

    if (form) {
      form.busy = false;
    }

    window.location.assign("/");
  },

  async fetchMe({ commit }) {
    try {
      const payload = await axios.post(route("api.@me"));
      commit("setMe", payload.data);
    } catch ({ errors, message }) {
      if (errors) {
        console.log(errors);
      }

      if (message) {
        console.log(message);
      }
    }
  }
};

const mutations = {
  setMe: (state, payload) => {
    state.me = payload;
  },
  isAuthenticated: (state, payload) => {
    state.isAuthenticated = typeof payload === "boolean" ? payload : payload.isAuthenticated;
  },
  logout: state => {
    state.me = null;
    state.isAuthenticated = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
